module.exports = __webpack_public_path__ + "img/audio_classify12.d4d1c81b.png";